// Author YuJiaBei
// Date 2020-08-07 15:55:23

class EmLcAdjustedReportAdr {
constructor({
        id = null,
        adrCodeSde = '',
        adrCodeBda = '',
        adrCodeLoc = '',
        adrAdjustedStartTime = '',
        adrAdjustedEndTime = '',
        adrAdjustedSummary = '',
        adrAdjustedAttachment = '',
        adrDescription = '',
        adrAdjustedAttachmentList = ''}
= {}) {
    this.id = id;
    this.adrCodeSde = adrCodeSde;
    this.adrCodeBda = adrCodeBda;
    this.adrCodeLoc = adrCodeLoc;
    this.adrAdjustedStartTime = adrAdjustedStartTime;
    this.adrAdjustedEndTime = adrAdjustedEndTime;
    this.adrAdjustedSummary = adrAdjustedSummary;
    this.adrAdjustedAttachment = adrAdjustedAttachment;
    this.adrDescription = adrDescription;
    this.adrAdjustedAttachmentList = adrAdjustedAttachmentList;
}
}

function newEntity() {
return new EmLcAdjustedReportAdr();
}

function gridFields() {
return Object.freeze([
        {
        key: 'adrCodeSde',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.adrCodeSde',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'adrCodeBda',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.adrCodeBda',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBdaName',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.emArchBdaName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'adrCodeLoc',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.adrCodeLoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchLocName',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.emArchLocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'adrAdjustedStartTime',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.adrAdjustedStartTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'adrAdjustedEndTime',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.adrAdjustedEndTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'adrAdjustedSummary',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.adrAdjustedSummary',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'adrAdjustedAttachmentList',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.adrAdjustedAttachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'adrInitiatorLoginName',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.adrInitiatorLoginName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'adrApplyTime',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.adrApplyTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'adrDescription',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.adrDescription',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    adrCodeSdeFilter : "",
    statusFilter : "",
    workOrderCodeFilter : "",
    adrCodeBdaFilter : "",
    adrCodeLocFilter : "",
    adrAdjustedStartTimeRteFilter : "",
    adrAdjustedStartTimeLteFilter : "",
    adrAdjustedEndTimeRteFilter : "",
    adrAdjustedEndTimeLteFilter : "",
    adrAdjustedSummaryFilter : "",
    adrInitiatorFilter : "",
    adrInitiatorLoginNameFilter : "",
    workflowQueryTypeFilter : "",
    emAclDeptIdFilter : "",
    emAclDeptNameFilter : "",
    emAclDeptNodeCodeFilter : "",
    emAclDeptNodeCodeNameFilter : "",
    emArchLocCodeFilter : "",
    emArchLocNodeCodeFilter : "",
    emArchLocNodeCodeNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'adrCodeSdeFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.adrCodeSde',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'EmLcAdjustedReportAdr',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'adrCodeBdaFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.adrCodeBda',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'adrAdjustedStartTimeRteFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.adrAdjustedStartTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'adrAdjustedStartTimeLteFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.adrAdjustedStartTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'adrAdjustedEndTimeRteFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.adrAdjustedEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'adrAdjustedEndTimeLteFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.adrAdjustedEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'adrAdjustedSummaryFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.adrAdjustedSummary',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'adrInitiatorLoginNameFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.adrInitiatorLoginName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"adrInitiator":"id"}'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        },
        {
        key: 'emArchLocCodeFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.emArchLocCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emArchLocNodeCodeNameFilter',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.filter.emArchLocNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emArchLocNodeCode":"nodeCode"}'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'adrCodeSde',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.entity.adrCodeSde',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'adrCodeBda',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.entity.adrCodeBda',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'adrCodeLoc',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.entity.adrCodeLoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'adrAdjustedStartTime',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.entity.adrAdjustedStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'adrAdjustedEndTime',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.entity.adrAdjustedEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'adrAdjustedSummary',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.entity.adrAdjustedSummary',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'adrDescription',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.entity.adrDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'adrAdjustedAttachmentList',
        label: 'label.em.lifecycle.emLcAdjustedReportAdr.entity.adrAdjustedAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'adrAdjustedAttachment'
                }
        }
]

export {EmLcAdjustedReportAdr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
